import { Component, app } from "modular-openscriptjs";
import { dc } from "../../declarations";
import { empty, setSearchQuery } from "../../helpers";

const h = app("h");

export default class SearchSuggestions extends Component {
    constructor() {
        super();
        dc.searchSuggestions.listener(this);
    }

    render(...args) {
        if (empty(dc.searchSuggestions?.value)) {
            return h.empty();
        }

        return h.div(
            {
                class: "position-absolute w-100 bg-white border rounded-4 shadow-sm mt-2",
                style: "top: 100%; left: 0; z-index: 1050; max-height: 350px; overflow-y: auto;",
            },
            h.ul(
                {
                    class: "list-group list-group-flush mb-0 d-flex flex-col gap-3 p-3",
                },
                ...dc.searchSuggestions?.value?.map((suggestion) =>
                    h.li(
                        {
                            class: "list-group-item-action border-0 d-flex align-items-center gap-2 text-dark rounded-3",
                            style: "cursor: pointer; transition: background-color 0.2s;",
                            onclick: this.method(
                                "selectSuggestion",
                                suggestion,
                            ),
                        },
                        h.div(
                            {
                                class: "circle d-flex align-items-center justify-content-center bg-light",
                                style: "width: 32px; height: 32px;",
                            },
                            h.i({ class: "bi bi-search text-muted small" }),
                        ),
                        h.span({ class: "fw-medium" }, suggestion),
                    ),
                ),
            ),
            ...args,
        );
    }

    selectSuggestion(suggestion) {
        setSearchQuery(suggestion);
        dc.searchSuggestions.value = [];
    }
}
